module.exports = __webpack_public_path__ + "static/404-bottom-min-1aa40c282263734335c11097a07c717c.png";